module.exports = __webpack_public_path__ + "public/images/fastcompany@2x.7a68f5945b940e618347332631ab9a55.png";